import Vue from "vue";
import Router from "vue-router";

import { jobs } from "./jobs";
import { travels } from "./travels";
import { fashion } from "./fashion";
import { health } from "./health";

import { requireAccess } from "./permission";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Verticals",
      component: () => import("views/verticals/Verticals"),
      title: "Principal",
      icon: "fa-home",
      type: "default",
      menu: true,
      editorAccess: true,
      beforeEnter: requireAccess,
      meta: {
        permission: "editor",
      },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("views/login/Login"),
      title: "Login",
    },
    {
      path: "/logout",
      name: "Logout",
      component: () => import("views/login/Login"),
      title: "Logout",
    },
    {
      path: "/recuperar-senha",
      name: "ForgotPassword",
      component: () => import("views/forgot-password/ForgotPassword"),
      title: "Recuperar senha",
    },
    {
      path: "/usuarios/:type?/:page?/:id?",
      name: "Users",
      component: () => import("views/users/Main"),
      title: "Usuários",
      icon: "fa-users",
      type: "default",
      menu: true,
      adminAccess: true,
      subitems: [
        {
          title: "Listar",
          type: "listar",
          submenu: true,
        },
        {
          title: "Cadastrar",
          type: "cadastrar",
          submenu: true,
        },
        {
          title: "Editar",
          type: "editar",
          submenu: false,
        },
      ],
      beforeEnter: requireAccess,
      meta: {
        permission: "admin",
      },
    },
    {
      path: "/meu-perfil",
      name: "MyProfile",
      component: () => import("views/my-profile/Main"),
      title: "Meu perfil",
      type: "default",
    },
    {
      path: "/integrator",
      name: "Integrator",
      component: () => import("views/integrator/Main"),
      title: "Integrator",
      icon: "fa-search",
      type: "default",
      menu: true,
      adminAccess: true,
      beforeEnter: requireAccess,
      meta: {
        permission: "admin",
      },
    },
    {
      path: "/401",
      name: "Page401",
      component: () => import("views/page401/Page401"),
      title: "Acesso não autorizado",
      type: "default",
    },
    {
      path: "/500",
      name: "Page500",
      component: () => import("views/page500/Page500"),
      title: "Erro interno do servidor",
      type: "default",
    },
    {
      path: "/em-construcao",
      name: "UnderConstruction",
      component: () => import("views/under-construction/UnderConstruction"),
      title: "Em construção",
      type: "default",
    },
  ].concat(jobs, travels, health, fashion, {
    path: "/*",
    name: "Page404",
    component: () => import("views/page404/Page404"),
    title: "Página não encontrada",
    type: "default",
  }),
  mode: "history",
  base: "/cms/",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js